interface SessionStorageObject {
  [key: string]: string | string[] | number | boolean | null | undefined;
}

export function getSessionStorageObject(key: string) {
  if (typeof window !== 'undefined') {
    const storedString = window.sessionStorage.getItem(key);
    if (storedString) {
      try {
        return JSON.parse(storedString);
      } catch (_error) {
        // console.error('Error parsing sessionStorage item:', error);
      }
    }
  }
  return null;
}

export function setSessionStorageObject(key: string, value: SessionStorageObject) {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }
}

export function updateSessionStorageObject(key: string, value: SessionStorageObject) {
  if (typeof window !== 'undefined') {
    const updatedAt = Date.now();
    const existingData = getSessionStorageObject(key) || {};
    const newData = { ...existingData, ...value, updatedAt };
    setSessionStorageObject(key, newData);
  }
}

export function removeSessionStorageItem(key: string) {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(key);
  }
}
